import React, { useEffect, useState } from 'react';
import { useParams, useRouteMatch } from 'react-router-dom';
import {
  deleteCandidateSkill,
  fetchCandidateSkills,
  postCandidateSkill,
} from '../../../api/candidate';
import { fetchPeriods } from '../../../api/period';
import { useFecth, useNotification } from '../../../hooks';
import Section from '../../common/section';
import Wrapper from '../wrapper';

const Edit = ({title,reloadCandidateUpdatedAtData}) => {
  const isEnabled = useRouteMatch({
    path: '/candidates/:hash/edit',
    exact: true,
  });
  const { hash } = useParams();
  const notifications = useNotification();
  const [changes, setChanges] = useState(0);
  const [skillsXPeriod, setSkillsXPeriod] = useState([]);
  const { result: periods } = useFecth(fetchPeriods);
  const { result, isLoading } = useFecth(fetchCandidateSkills, hash, [
    hash,
    changes,
  ]);

  useEffect(() => {
    if (!isLoading) setSkillsXPeriod(result);
  }, [result, isLoading]);

  if (!Array.isArray(periods) || periods.length === 0) return null;

  function handleSelect({ hash: period }, { hash: skill }) {
    postCandidateSkill(hash, { period, skill, immediately: true }).then((res) => {
      if (res.success) {
        setChanges((prev) => prev + 1);
        reloadCandidateUpdatedAtData();
      } else notifications.error(res.error);
    }
    );
  }

  function handleDelete({ hash: skill }) {
    deleteCandidateSkill(hash, { skill, immediately: true }).then((res) =>
      res.success
        ? setChanges((prev) => prev + 1)
        : notifications.error(res.error)
    );
  }

  return (
    <Section title={title} disabled={!isEnabled}>
      {periods.map((period) => {
        const sxp =
          skillsXPeriod &&
          skillsXPeriod.find((sxp) => sxp.hash === period.hash);
        return (
          <Wrapper
            edit={true}
            key={period.hash}
            period={period}
            skills={sxp ? sxp.skills : []}
            onSelectSkill={handleSelect}
            onDeleteSkill={handleDelete}
          />
        );
      })}
    </Section>
  );
};

export default Edit;
